import React from "react";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const PermissionGuard = ({ children, allowedPermissions }) => {
  const token = Cookies.get("vaghfnamaUser");
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const isCampaign = params.get("campaign") === "true";

  if (isCampaign) {
    return children;
  }

  if (!token) {
    return <Redirect to="/auth/login" replace />;
  }

  const decodedToken = JSON.parse(token);

  const userPermissions = decodedToken.permissions || [];

  const hasPermissionAccess = allowedPermissions.some((permission) =>
    userPermissions.includes(permission)
  );

  if (!hasPermissionAccess) {
    return <Redirect to="/auth/unauthorized" replace />;
  }

  return children;
};

export default PermissionGuard;
